<template>
  <BAutocompleteSelect
    ref="autocomplete"
    v-bind="$attrs"
    label="Тип хранилища"
    no-data-text="Тип не найден"
    :options="options"
    :return-object="false"
    item-text="label"
    item-value="id"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { StorageTypeOptions } from '@/typings/api/Publication'

import BAutocompleteSelect from './BAutocompleteSelect.vue'


export default {
  name: 'BAutocompleteStorageType',
  components: {
    BAutocompleteSelect,
  },
  mixins: [
    openApiMixin,
  ],
  data: () => ({
    options: Object.values(StorageTypeOptions),
  }),
}
</script>
